/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useEffect, useState } from 'react'
import clsx from 'clsx'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import {
  HeaderNotificationsMenu,
  HeaderUserMenu,
  QuickLinks,
  Search,
  ThemeModeSwitcher,
} from '../../../partials'
import { MenuItem } from './MenuItem';
import { Button } from 'react-bootstrap';

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40p',
  toolbarPerpusHeightClass = 'symbol-30px symbol-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'fs-1'

const handleBackOffice = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
  e.preventDefault();
  try {
    const sign = require('jwt-encode');

    const secretKey = 'vkJ2Iqfy0Xf4gstXaio3nnGxziqJIsRxvffmYYWlCWgXd4ObZYsaEqdy55ir52qt';

    const data = {
      iss: "https://lsp.kubuku.id",
      url: "https://lsp.kubuku.id",
      tipe: 'dashboard-perpus',
      id: localStorage.getItem('UID'),
    };

    const token = sign(data, secretKey);

    const redirectURL = `https://kubuku.id/new-perpus/login/?access_token=${token}`;
    window.location.href = redirectURL;
  } catch (error) {
    console.error('Error:', error);
  }
};

const Topbar: FC = () => {

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      <div className='topbar d-flex align-items-stretch flex-shrink-0'>

        {/* begin::Perpus */}
        <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
          <a href="#" className='text-white fw-semibold' onClick={handleBackOffice}>Backoffice Perpustakaan</a>
        </div>

        {/* begin::Theme mode */}
        <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
          <ThemeModeSwitcher toggleBtnClass={toolbarButtonHeightClass} />
        </div>


        {/* end::Theme mode */}

        {/* begin::User */}
        <div
          className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          {/* begin::Toggle */}
          <div
            className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            <img
              className='h-30px w-30px rounded'
              src={toAbsoluteUrl('/media/avatars/blank.png')} // Menggunakan toAbsoluteUrl untuk mendapatkan jalur absolut gambar
              alt='metronic'
            />
          </div>
          <HeaderUserMenu /> {/* Memanggil komponen HeaderUserMenu */}
          {/* end::Toggle */}
        </div>
        {/* end::User */}
      </div>
    </div>
  )
}




export { Topbar }
